import React from "react";
import { LeadConsultationForm } from "@/components/LeadConsultationForm";
import { GoogleReviewsWidget } from "@/components/GoogleReviewsWidget";

export const TestimonialsPage: React.FC = () => {
  return (
    <div className="pt-24 pb-20 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <span className="text-xs font-extrabold uppercase tracking-widest text-primary bg-primary/10 px-3 py-1 rounded-md">
            Real Owner & Resident Stories
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 dark:text-white tracking-tight">
            Client Testimonials
          </h1>
          <p className="text-slate-600 dark:text-slate-300 text-base">
            Read what property owners and residents say about partnering with
            Feingold Property Management.
          </p>
        </div>

        <div className="max-w-5xl mx-auto mb-16">
          <GoogleReviewsWidget />
        </div>

        <div className="max-w-3xl mx-auto">
          <LeadConsultationForm title="Experience Premium Management Firsthand" />
        </div>
      </div>
    </div>
  );
};
